import React, { useState } from 'react';

export default function Collapse({
    head,
    body,
    maxHeight = '0px',
    key,
    controls = null,
}) {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const collapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <div className='basic-collapse' key={key}>
            <div 
                className='basic-collapse-head'
                onClick={collapse}
            >
                <div className='basic-collapse-head__label'>
                    <b>{head}</b>
                </div>
                {
                    controls &&
                    <div className='basic-collapse-head__controls'>
                        {controls}
                    </div>
                }
            </div>
            <div 
                className='basic-collapse-body'
                style={
                    isCollapsed ? { maxHeight: '0px', padding: 0 } : { maxHeight, padding: '10px' }
                }
            >
                { body }
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/common/CollapseBasic.jsx